import {EventDispatcher, Event} from 'EventDispatcher';
export class CustomDataEvent extends Event {

    private _data?: any;

    constructor(type: string) {
        super(type);
    }

    public get data(){
        return this._data;
    }

    public set data(value: any){
        this._data = value
    }

}